import styled from 'styled-components';
import { buttonReset } from '../../styled/buttons';
import { breakpoint } from '../../theme/breakpoint';
import LinkHandler from '../../link-handler';
import { MobileButtonWrapper, MobileMenuBtn } from '../buttons/styles';

export const NavigationHeader = styled(MobileButtonWrapper)`
  margin: ${({ theme }) => theme.spacing.tiny};

  button${MobileMenuBtn} {
    margin-left: auto;
  }
`;

export const NavigationWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: auto;
  max-height: 100%;
  overflow-y: auto;
  background: ${({ theme }) => theme.palette.white};
  box-shadow: ${({ theme }) => theme.boxshadow.menu};
  transform: ${({ $active }) =>
    $active ? 'translateX(0)' : ' translateX(120%)'};
  ${({ $active }) => ($active ? `z-index: 20;` : `visibility: hidden;`)};

  ${breakpoint.desktop`
    position: relative;
    width: 100%;
    box-shadow: none;
    transform: none;
    overflow-y: visible;
    z-index: unset;
    background: transparent;
    ${({ $active }) => !$active && `visibility: visible;`};
  `}
`;

export const MenuList = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;

  ${breakpoint.desktop`
    flex-direction: row;
    width: auto;
    position: relative;
  `}
`;

export const Menus = styled.nav`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) =>
    `${theme.spacing.small} ${theme.spacing.standard} 0`};

  ${breakpoint.desktop`
    flex-direction: row;
    justify-content: flex-end;
    max-width: ${({ theme }) => theme.sizes.maxWidth};
    margin: 0 auto;
    padding: 0;
  `}
`;

export const Item = styled.li`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 0;
  border-bottom: 1px solid #ccc;
  justify-content: space-between;

  ${breakpoint.desktop`
    border-bottom: none;
    padding: 0;
    ${({ $primaryNav }) => $primaryNav && `z-index: 10;`};

    // no margin right on final item, margin-left provided by donate button
    &:not(:last-of-type) {
      margin-right: ${({ theme }) => theme.spacing.medium};
    }
  `}
`;

export const ItemLink = styled(LinkHandler)`
  position: relative;
  color: ${({ theme }) => theme.palette.standardText};
  font-size: ${({ theme }) => theme.fontsize.base};
  padding: 16px 0 15px 0;
  text-decoration: none;
  flex-grow: 1;

  &:hover {
    text-decoration: none;
  }
  &::after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }

  ${({ theme, $activeNavItem }) =>
    $activeNavItem &&
    `  
      span {
        border-bottom: 4px solid ${theme.palette.secondaryButton};
        padding-bottom: 14px;
      }
  `}

  ${breakpoint.desktop`
    padding: 3px 0;
    &::after {
      bottom: -25px;
    }
    &:hover::after {
      border-bottom: ${({ theme }) => `4px solid ${theme.palette.primaryLink}`};
    }

    ${({ $activeNavItem }) =>
      $activeNavItem &&
      `  
      span {       
        padding-bottom: 26px;
      }
    `}
  `}
`;

// Same as ItemLink, but for links that are empty for popping
// open sub-menus
export const BlankLink = styled.button`
  ${buttonReset}
  color: ${({ theme, $active }) =>
    $active ? theme.palette.brand : theme.palette.standardText};
  font-size: ${({ theme }) => theme.fontsize.small};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  text-decoration: none;
`;

export const AdditionalMenu = styled(MenuList)`
  ${breakpoint.desktop`
    flex-direction: row;
    li:last-of-type {
      margin-right: 0;
    }
  `}
`;
export const SubMenuUl = styled.ul`
  display: ${({ $active }) => ($active ? 'flex' : 'none')};
  width: 100%;
  flex-direction: column;
  padding-left: ${({ theme }) => theme.spacing.standard};
  border-bottom: 1px solid ${({ theme }) => theme.palette.border}; // active on mobile
  list-style: none;
  z-index: 10;

  ${breakpoint.desktop`
    position: absolute;
    max-width: 530px;
    display: ${({ $legal }) => $legal && 'none'};
    top: calc(100% + 3px);
    left: 0;
    flex-direction: row;
    flex-wrap: wrap;
    padding: ${({ theme }) =>
      `21px ${theme.spacing.medium} ${theme.spacing.small}`};
    box-shadow: ${({ theme }) => theme.boxshadow.menu};
    background: ${({ theme }) => theme.palette.white};
    border: 2px solid ${({ theme }) => theme.palette.border};
  `}

  ${Item} {
    &:last-child {
      border: none;
    }

    ${breakpoint.desktop`
      flex: 0 1 50%;
      margin: 0;
      border: none;

      ${ItemLink} {
        font-size: ${({ theme }) => theme.fontsize.base};
        text-decoration: underline;
        display: block;
        width: 100%;

        &::after {
          content: none;
        }
      }
    `}
  }

  ${ItemLink} {
    font-size: ${({ theme }) => theme.fontsize.small};
    padding: 0;
    margin: 15px 8px 14px 8px;

    ${({ $activeNavItem }) =>
      $activeNavItem &&
      `
      span {
          padding-bottom: 13px;
        }
      }
    `}

    &::after {
      left: ${({ theme }) => theme.spacing.tiny};
      position: relative;
      bottom: -14px;
      left: 0;
    }

    ${breakpoint.desktop`
      margin: ${({ theme }) => `0 0 ${theme.spacing.small} 0`}; 

      span {
        border-bottom: 0;
        padding-bottom: 0;
      }
      
    `}
  }
`;

export const SkipToContent = styled.a`
  display: block;
  width: 100%;
  max-width: ${({ theme }) => theme.sizes.maxWidth};
  height: 0;
  margin: 0 auto;
  overflow: hidden;

  &:focus {
    height: auto;
  }
`;
